import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-page-status-indicator',
    templateUrl: './page-status-indicator.component.html',
    styleUrls: ['./page-status-indicator.component.scss'],
    standalone: false,
})
export class PageStatusIndicatorComponent {
    @Input() isReceivingData: boolean;
    @Input() numberOfAlarms: number;
    @Input() pageTitle: string;
    @Input() pageItems: number;
}
